module.exports = __webpack_public_path__ + "static/img/3.3816e21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/11/3.png
// module id = ZaM7
// module chunks = 0